import React from "react";
import { Route, Switch } from "polyrouter";
import { PolyPlusRouter } from "./PolyPlus/PolyPlusRouter";
import "./Licensing.scss";
import { ClaritiRouter } from "./Clariti/ClaritiRouter";
import { needs } from "TsRoleGuards";
import { any, protect } from "rbac";
import { SharedLicensingRouter } from "./Shared/SharedLicensingRouter";

export enum LicensingType {
  POLY_PLUS = "POLY_PLUS",
  CLARITI = "CLARITI"
}

const LicensingRouter: React.FC = () => {
  return (
    <div className="licensing">
      <Switch nest>
        <Route path="/poly-plus">
          <PolyPlusRouter />
        </Route>
        <Route path="/clariti">
          <ClaritiRouter />
        </Route>
        <Route path="">
          <SharedLicensingRouter />
        </Route>
      </Switch>
    </div>
  );
};

const ProtectedLicensingRouter = protect(
  any([needs("get:polypluslicense"), needs("license:ReadTenant")])
)(LicensingRouter);

export { ProtectedLicensingRouter as LicensingRouter };
